import { render, staticRenderFns } from "./collectConfig.vue?vue&type=template&id=45fb3d4b"
import script from "./collectConfig.vue?vue&type=script&lang=js"
export * from "./collectConfig.vue?vue&type=script&lang=js"
import style0 from "./collectConfig.vue?vue&type=style&index=0&id=45fb3d4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports